import { evolutionPathPair } from "../../evolutions/evolutionPath";
import axios from "../api";
/**
 * The pathways one option away from a chosen one.
 *
 * `chain` ends with the pathway evolution and `pathwayChain` with its selected
 * pathway. `nextSteps` holds one entry per neighboring pathway, each graded
 * from the player before the pathway evolution.
 */
export const getPathwayOptions = async ({ resourceId, chain, pathwayChain, assetId, evoPathId, playerRoleIds, }) => {
    const { evolutionPath, pathwayPath } = evolutionPathPair(chain, pathwayChain);
    const res = await axios.post(`/players/${resourceId}/next-evo-steps/pathway-options`, {
        evoPath: evolutionPath,
        pathwayPath,
        ...(evoPathId && { evoPathId }),
        ...(playerRoleIds?.length && { playerRoleIds }),
        ...(assetId && { assetId }),
        v: 2,
    });
    return res.data;
};
//# sourceMappingURL=getPathwayOptions.js.map